import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import appConfig from './environments/environments'
import { ReactAuthWrapper } from '@carrier-sce-sharedpackages/reactauthwrapper'
import { UserProvider, UserContext } from './context/userContext'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { transformUserInfo } from './types/user'

// Create complete theme
const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2',
            light: '#42a5f5',
            dark: '#1565c0',
            contrastText: '#fff',
        },
        secondary: {
            main: '#dc004e',
            light: '#f73378',
            dark: '#9a0036',
            contrastText: '#fff',
        },
        error: {
            main: '#f44336',
        },
        warning: {
            main: '#ff9800',
        },
        info: {
            main: '#2196f3',
        },
        success: {
            main: '#4caf50',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
})

const AppWrapper = () => {
    const { setUser } = React.useContext(UserContext)

    const handleGetPermissions = (userInfo) => {
        const user = transformUserInfo(userInfo)
        setUser(user)
    }

    return (
        <ReactAuthWrapper appConfig={appConfig} getPermissions={handleGetPermissions}>
            <App />
        </ReactAuthWrapper>
    )
}

createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <UserProvider>
                <AppWrapper />
            </UserProvider>
        </ThemeProvider>
    </React.StrictMode>
)
